export default "__VITE_ASSET__ntKwkUtl__"